module.exports = __webpack_public_path__ + "images/no_position.png";


//////////////////
// WEBPACK FOOTER
// ./public/no_position.png
// module id = 2296
// module chunks = 0